import Confetti from "../icons/confetti.jsx";
import Wink from "../icons/wink.jsx";

import { globalT } from "../utils/globalUtils.js";

const Result = (props) => {
  const resultClass = props.result ? "m-correct" : "m-incorrect";
  const resultText = props.result
    ? globalT("¡Felicidades! la respuesta ha sido acertada")
    : `${globalT("¡Oh!")} ${globalT(
        "Tu respuesta no ha sido la más acertada"
      )}. ${globalT("¿Quieres volver a intentarlo")}?`;

  return (
    <div className={`m-result ${resultClass}`}>
      <div className="m-result-txt">{resultText}</div>
      {props.result ? <Confetti /> : <Wink />}
    </div>
  );
};
export default Result;
